import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function OpportunityCost() {
  const costData = [{
    without: 'Llegar a la práctica sin una estructura clara',
    cost: 'Valoraciones incompletas, inseguridad frente al paciente'
  }, {
    without: 'Estudiar signos vitales y red flags de memoria',
    cost: 'No sabés interpretar cambios clínicos reales'
  }, {
    without: 'Administrar medicación con dudas',
    cost: 'Más miedo a equivocarte, más dependencia de otros'
  }, {
    without: 'Sin sistema de razonamiento clínico',
    cost: 'Priorización débil, decisiones inseguras'
  }, {
    without: 'Sin plantillas ni registros modelo',
    cost: 'Documentación pobre y desordenada'
  }, {
    without: 'Sin casos clínicos resueltos',
    cost: 'La lógica clínica tarda mucho más en desarrollarse'
  }, {
    without: 'Otro año estudiando con material disperso',
    cost: 'El mismo ciclo, la próxima práctica'
  }];
  return <section className="py-12 md:py-20 lg:py-24 bg-clinical-base" data-id="element-222">
      <div className="max-w-[1000px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-223">
        <div className="text-center mb-10 md:mb-12" data-id="element-224">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-[10px] sm:text-xs font-semibold tracking-[0.22em] uppercase text-clinical-mid mb-4" data-id="element-225">
            El costo real
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl md:text-5xl font-black text-clinical-deep mb-3 leading-[1.05] uppercase" data-id="element-226">
            ¿Cuánto cuesta{' '}
            <span className="accent-italic normal-case" data-id="element-227">no tenerlo?</span>
          </motion.h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="md:hidden space-y-3 mb-10" data-id="element-228">
          {costData.map((row, idx) => <div key={idx} className="bg-white rounded-2xl border border-clinical-line overflow-hidden" data-id="element-229">
              <div className="bg-clinical-deep text-white px-4 py-3 text-sm font-bold" data-id="element-230">
                {row.without}
              </div>
              <div className="p-4 flex items-start gap-2.5" data-id="element-231">
                <AlertCircle className="w-4 h-4 text-clinical-ink/50 flex-shrink-0 mt-0.5" data-id="element-232" />
                <span className="text-sm text-clinical-ink leading-snug" data-id="element-233">
                  {row.cost}
                </span>
              </div>
            </div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="hidden md:block bg-white rounded-2xl overflow-hidden border border-clinical-line mb-12" data-id="element-234">
          <div className="overflow-x-auto" data-id="element-235">
            <table className="w-full text-left border-collapse min-w-[600px]" data-id="element-236">
              <thead data-id="element-237">
                <tr className="bg-clinical-deep text-white" data-id="element-238">
                  <th className="p-5 font-bold text-base w-1/2" data-id="element-239">
                    Sin Mega Pack Enfermería
                  </th>
                  <th className="p-5 font-bold text-base w-1/2" data-id="element-240">Costo real</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-clinical-line" data-id="element-241">
                {costData.map((row, idx) => <tr key={idx} data-id="element-242">
                    <td className="p-5 text-clinical-deep font-semibold" data-id="element-243">
                      {row.without}
                    </td>
                    <td className="p-5 text-clinical-ink/80" data-id="element-244">
                      <div className="flex items-start gap-2" data-id="element-245">
                        <AlertCircle className="w-5 h-5 text-clinical-ink/40 flex-shrink-0 mt-0.5" data-id="element-246" />
                        <span data-id="element-247">{row.cost}</span>
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto text-center space-y-3" data-id="element-248">
          <p className="text-base md:text-lg text-clinical-ink leading-relaxed" data-id="element-249">
            El próximo turno, la próxima práctica o el próximo examen pueden
            sentirse distintos.
          </p>
          <p className="text-xl md:text-3xl font-black text-clinical-deep leading-tight pt-2 uppercase" data-id="element-250">
            Sino porque llegás con un{' '}
            <span className="accent-italic normal-case" data-id="element-251">sistema.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}